<script setup>

import {computed, onMounted, reactive} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

onMounted(() => {
  listAll()
});


const data = reactive({
  headers: [
    { title: 'ID', key: 'id', align: ' d-none'},
    { title: 'Claim Number', key: 'claimnumber'},
    { title: 'Person Insured', key: 'insuredname' },
    { title: 'Client', key: 'client' },
    { title: 'Date/Time', key: 'time', },
    { title: 'Sent By', key: 'name' },
    { title: 'Message', key: 'message' },
    { title: 'Age', key: 'age' },
  ],
  loading: false,
  messages: [],
  timezone: new Date(),
  selectedMessages: [],
  markingAsRead: false
});

const csvData = computed(()=> {

  // CSV File
  return data.messages.map((item) => ({
    ...item,
    message: item.message,
    name: item.name,
    time: formatTimestampByLocale(item.time),
  }))
});

const csvExport = (arrData) => {
  // CSV File
  let csvContent = 'data:text/csv;charset=utf-8,'
  csvContent += [
    Object.keys(arrData[0]).join(';'),
    ...arrData.map((item) => Object.values(item).join(';')),
  ]
      .join('\n')
      .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', 'export.csv')
  link.click()
};

const formatTimestampByLocale = (timestamp) => {
  const date = new Date(timestamp)
  const timeOptions = {
    hour12: true,
    hour: "numeric",
    minute: "2-digit",
  }
  const dateOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZoneName: "short"
  }
  return date.toLocaleString('en', {...dateOptions, ...timeOptions})
};

const getTimezone = () => {
  const tzName = data.timezone
  return tzName.toLocaleString('en', {timeZoneName: 'short'}).split(' ').pop();
};

const update = (item) => {
  data.loading = true;

  ApiWrapper.post('messaging','update-message', {
    id: item.id,
    status: item.is_read
  })
  .then((response) => {
    listAll();
    ToastUtil.successMsg('Updated message');
  })
  .catch((error) => {
    ToastUtil.error(error);
    data.loading = false;
  })
}

const listAll = () => {
  data.loading = true;

  ApiWrapper.post('messaging','list-messages', {
    adjuster: 'true'
  })
  .then((response) => {
    data.messages = response.messages;
  })
  .catch((error) => {
    ToastUtil.error(error);
  })
  .finally(()=>{
    data.loading = false
  })
}

const markAsRead = () => {
  if(!data.markingAsRead) {
    data.markingAsRead = true;

    ApiWrapper.post('messaging', 'bulk-mark-as-read', {
      messageIds: data.selectedMessages
    })
        .then((response) => {
          ToastUtil.successMsg(`Marked ${data.selectedMessages.length === 1 ? 'message' : 'messages' } as read!`);
          data.selectedMessages = [];
          listAll();
        })
        .catch((error) => {
          ToastUtil.error(error);
        })
        .finally(() => {
          data.markingAsRead = false;
        })
  }
};

const GetIsFireType = (claim) => {
  if(claim.claimtype) {
    return claim.claimtype.toString().toLowerCase().includes('fire')
  }
  return false;
};

</script>

<template>
  <v-container id="entreos-resize-target" fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Messages</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn
            size="small"
            variant="elevated"
            class="primary mr-2"
            :disabled="data.selectedMessages.length === 0"
            @click="markAsRead"
            :loading="data.markingAsRead"
        >
          Mark as Read
        </v-btn>
        <v-icon @click="csvExport(csvData)" v-if="csvData.length"> mdi-file-download</v-icon>
      </v-toolbar>
      <v-data-table
          v-model="data.selectedMessages"
          :items="data.messages"
          :headers="data.headers"
          :search="data.search"
          show-select
      >
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{ item.claimnumber }}
          </RouterLink>
          <span class="ma-ml-3" v-if="GetIsFireType(item)"> <v-icon color="orange">mdi-fire-circle</v-icon> </span>
        </template>
        <template v-slot:[`item.time`]="{ item }">
          {{ formatTimestampByLocale(item.time) }}
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>